<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>GST Details</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
    	<!-- main row for all icons  -->
			<div class="col-md-12">
				<button class="btn btn-primary fa fa-plus" @click="modalOpener('addModal')"> Add GST Details</button>
					<br><br>
				<div class="row">
					<div v-if="gsts.length == 0" style="margin-left: 10%">
     				<h5>No GST Details.</h5>
     				<img src="../images/nodata.svg" style="width: 100%;">
    			</div>
    			<div v-else class="col-sm-6" v-for="(g, index) in gsts" :key="index">
    				<div class="card">
      				<div class="card-body">
      					<b>GST No.: </b>{{g.gst_number}}
      					<br>{{g.details}}
      					<br>{{g.address}}
      					<h5>
      						<span class="badge bg-success" v-if="g.is_active=='Verified'">Verified</span>
      						<span class="badge bg-danger" v-else-if="g.is_active=='Unverified'">Unverified</span>
      					</h5>
      				</div>
      			</div>
					</div>
				</div>	
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->
<div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="addModal">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h4 class="modal-title">Add/Modify GST</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
         </div>
         <form @submit.prevent="addGST" @keydown="form.onKeydown($event)" role="form">
         <div class="modal-body">
         			<div :class="['form-group', errors.address1 ? 'has-error' : '']">
              	<label>GST Number</label>
                <input type="text" name="gst_number" v-model="form.gst_number" class="form-control" placeholder="Enter Your GST NUmber">
                <span v-if="errors.gst_number" :class="['badge bg-danger']">Enter a valid GST Number.</span>
              </div>
              <div :class="['form-group', errors.details ? 'has-error' : '']">
              	<label>Details</label>
                <input type="text" name="details" v-model="form.details" class="form-control" placeholder="Enter the Details">
                <span v-if="errors.details" :class="['badge bg-danger']">Enter a valid details.</span>
              </div>
              <div :class="['form-group', errors.address_id ? 'has-error' : '']">
              	<label>Address</label>
                <select v-model="form.address_id" class="form-group">
                	<option v-for="addr in addresses" :value="addr.id">{{addr.address1}}, {{addr.address2}}, {{addr.address3}}, {{addr.district}}, {{addr.state}}, {{addr.pincode}}</option>
                </select>
                <span v-if="errors.address_id" :class="['badge bg-danger']">Please choose a valid address.</span>
              </div>
         </div>
         <div class="modal-footer">
         		<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
         		<button type="submit" class="btn btn-primary">Add/Modify</button>
         </div>
         </form>
      </div>
   </div>
</div>
<br>
      <br>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getAddresses();
        	this.getGST();
        },
        
        data(){
       		return{
       			addresses: [],
       			form: new Form({
       				gst_number: '',
       				details: '',
       				user_id: this.$userId,
       				address_id: '',
       				id: ''
       			}),
       			errors: [],
       			gsts: []
       		} 
        },
        
        methods: {
        	getAddresses(){
        		axios.post("/api/getAddresses", {owner_id: this.$userId})
        		.then(response => {
        			this.addresses = response.data;
        		})
        	},
        	
        	getGST(){
        		axios.post("/api/getUserGST", {user_id: this.$userId})
        		.then(response => {
        			this.gsts = response.data;
        		})
        	},
        	
        	addGST(){
        		this.form.post("/api/addGST", {user_id: this.$userId})
        		.then(() => {
        			console.log("success");
        			this.getGST();
        		})
        	},
        	
        	modalOpener(id){
        		$("#"+id).modal("show");
        	},
        	
        	edit(gst){
        		this.form.fill(gst);
        		$("#addModal").modal("show");
        	},
        	
        	change(id, status){
        		axios.post("/api/changeGST", {id: id, status: status})
        		.then(() => {
        			this.getGST();
        		})
        	}
        }
    }
</script>
